enum AccountStatus {
  ACTIVE = "ACTIVE",
  MICRODEPOSITS_PENDING = "MICRODEPOSITS_PENDING",
  INACTIVE = "INACTIVE",
  DISCONNECTED = "DISCONNECTED",
  SUBMITTED = "SUBMITTED",
  REQUESTED = "REQUESTED",
}

export default AccountStatus;
